import React from 'react';
import PropTypes from 'prop-types';

const BenefitsSummary = ({ result }) => {
  const sentence = `${(result || '').trim()} to apply for Chapter 31 benefits`;

  return (
    <>
      <h2 className="vads-u-margin-top--0">Your benefits</h2>
      <p>
        If you apply and meet the basic eligibility criteria, we&rsquo;ll help
        you schedule your comprehensive initial evaluation appointment. Then,
        we&rsquo;ll determine if you meet the entitlement criteria and review
        the benefits and services that best match your individual employment or
        independent living needs.
      </p>

      <div className="vads-u-margin-bottom--3">
        <ul className="vads-u-margin--0 vads-u-padding-left--0">
          <li className="vads-u-display--flex vads-u-flex-direction--column vads-u-padding-y--2 vads-u-align-items--baseline vads-u-list-style--none">
            <span className="vads-u-font-weight--bold vads-u-min-width--18rem">
              Result
            </span>
            <span className="vads-u-margin--0">{sentence}</span>
          </li>
        </ul>
      </div>
    </>
  );
};

BenefitsSummary.propTypes = {
  result: PropTypes.string,
};

export default BenefitsSummary;
